/**
 * Verifica se una route è attiva basandosi sul path corrente.
 * Gestisce match esatti e sotto-pagine, evitando match errati.
 * 
 * @param href - L'URL della route da verificare (es. '/shipper/containers')
 * @param currentPath - Il path corrente (es. '/shipper/containers/123')
 * @returns true se la route è attiva, false altrimenti
 * 
 * @example
 * isRouteActive('/shipper/dashboard', '/shipper/dashboard') // true (match esatto)
 * isRouteActive('/shipper/containers', '/shipper/containers/123') // true (sotto-pagina)
 * isRouteActive('/shipper/dashboard', '/shipper/dashboard-settings') // false (evita match errati)
 */
export function isRouteActive(href: string | undefined, currentPath: string | undefined): boolean {
    // Se href o currentPath sono undefined o vuoti, non matchano
    if (!href || !currentPath) {
        return false;
    }

    // Match esatto
    if (href === currentPath) {
        return true;
    }

    // Verifica se currentPath inizia con href seguito da '/' o termina esattamente con href
    // Questo gestisce le sotto-pagine come /shipper/containers/123
    // Ma evita match errati come /shipper/dashboard-settings
    if (currentPath.startsWith(href + '/')) {
        return true;
    }

    return false;
}

